export const STRIPE_ACCOUNT_STATUS_VARIANTS = {
  not_created: 'secondary',
  pending: 'warning',
  restricted: 'warning',
  active: 'success',
  disabled: 'danger',
}

export const BUSINESS_VERIFICATION_STATUS_VARIANTS = {
  verified: 'success',
  pending: 'warning',
  action_required: 'danger',
}

export const CHARITY_VERIFICATION_STATUS_VARIANTS = {
  pending: 'warning',
  verified: 'success',
  suspended: 'danger',
  withdrawn: 'secondary',
}

export const CHARITY_ONBOARDING_STEPS = [
  'not_started',
  'details_submitted',
  'pending_review',
  'verified',
]

export function getStripeAccountStatus(stripeStatus) {
  return stripeStatus?.stripe_account_status || 'not_created'
}

export function isCharityStripeSuspended(stripeStatus) {
  return getStripeAccountStatus(stripeStatus) === 'suspended'
}

export function isCharityStripeVerified(stripeStatus) {
  return (
    stripeStatus?.verified_by_stripe === true &&
    !isCharityStripeSuspended(stripeStatus)
  )
}

export function isCharityStripeComplete(stripeStatus) {
  return isCharityStripeVerified(stripeStatus)
}

export function getCharityVerificationBadgeKey(stripeStatus) {
  const status = getStripeAccountStatus(stripeStatus)
  if (status === 'suspended') return 'suspended'
  if (status === 'disabled') return 'withdrawn'
  if (isCharityStripeVerified(stripeStatus)) return 'verified'
  return 'pending'
}

export function getCharityOnboardingStep(stripeStatus) {
  if (isCharityStripeVerified(stripeStatus)) return 'verified'
  if (stripeStatus?.stripe_details_submitted) return 'pending_review'
  if (stripeStatus?.has_stripe_account) return 'details_submitted'
  return 'not_started'
}

export function getCharityOnboardingStepIndex(stripeStatus) {
  const step = getCharityOnboardingStep(stripeStatus)
  const index = CHARITY_ONBOARDING_STEPS.indexOf(step)
  return index === -1 ? 0 : index
}

export function getCharityStripeRejectionReason(stripeStatus) {
  if (isCharityStripeSuspended(stripeStatus)) return null
  return stripeStatus?.stripe_disabled_reason || null
}

export function getBusinessVerificationBadgeKey(stripeStatus) {
  if (stripeStatus?.verified_by_stripe) return 'verified'
  const status = getStripeAccountStatus(stripeStatus)
  if (status === 'restricted' || status === 'disabled') return 'action_required'
  return 'pending'
}

export function isBusinessStripeVerified(stripeStatus) {
  return stripeStatus?.verified_by_stripe === true
}

export function extractStripeApiError(error, fallback = 'Request failed') {
  const data = error?.response?.data
  if (typeof data?.error === 'string' && data.error.length > 0) {
    return data.error
  }
  if (data?.errors?.full_messages?.[0]) {
    return data.errors.full_messages[0]
  }
  if (Array.isArray(data?.errors) && data.errors[0]) {
    return data.errors[0]
  }
  return error?.message || fallback
}

export function isExistingStripeAccountError(message) {
  if (!message) return false
  const lower = message.toLowerCase()
  return lower.includes('already') || lower.includes('exists')
}
